<script>
export default {
  name: "PrivacyPolicy"
};
</script>

<template>
  <iframe
    class="col-lg-8 col-md-12 border-0 p-0"
    height="1000"
    src="https://d25jgir1i1391d.cloudfront.net/terms/privatlivspolitik-da/index.html"
  />
</template>
